import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import {
  TextInputLabel,
  RequiredFieldDivError,
} from "../AddEditSolution.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";

const CenterList = (props) => {
  const {
    t,
    formData,
    setFormData,
    isEditMode,
    centreList,
    onFilterApply,
    onCentresSelect,
    centreLoading,
  } = props;

  const [selectedCompany, setSelectedCompany] = useState([]);

  useEffect(() => {
    setFormData({
      ...formData,
      centre: {
        value: selectedCompany,
        error: "",
        required: true,
      },
    });
    if (selectedCompany?.id) onCentresSelect(selectedCompany);
  }, [selectedCompany]);

  const searchEntity = (e) => {
    onFilterApply("", e.target.value);
  };

  return (
    <>
      <TextInputLabel error={formData.centre.error}>
        {" "}
        {t("CENTER")}
        {centreLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        id="tags-outlined"
        options={centreList}
        disabled={!!isEditMode}
        getOptionLabel={(option) => option.name || " "}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              formData.centre.error !== ""
                ? autoSearchInputStylesError
                : autoSearchInputStyles
            }
          />
        )}
        value={formData.centre.value}
        onKeyUp={searchEntity}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      {formData.centre.error !== "" && (
        <RequiredFieldDivError>{formData.centre.error}</RequiredFieldDivError>
      )}
    </>
  );
};

CenterList.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
};

CenterList.defaultProps = {
  isEditMode: false,
};
export default withTranslation()(CenterList);
